export default {
  "content": "<path fill=\"#BB2E12\" d=\"M19.777 15.29L11.444 1.07c-.638-1.094-2.247-1.094-2.89 0L.226 15.29c-.641 1.09.157 2.46 1.442 2.46h16.665c1.28 0 2.08-1.367 1.444-2.46zM9.06 5.561a.938.938 0 011.876 0v5c0 .518-.42.938-.903.938-.482 0-.973-.418-.973-.938v-5zM10 15.25a1.228 1.228 0 110-2.457 1.228 1.228 0 010 2.457z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "18",
    "fill": "none",
    "viewBox": "0 0 20 18"
  }
};